import {
  ADD_Holiday,
  GET_Holiday,
  UPDATE_Holiday,
  DELETE_Holiday,
} from "../type";
import { InsertData } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";

export function buildHolidayQuery(params = {}) {
  const searchParams = new URLSearchParams();
  const normalized = {
    SearchTerm: params.searchTerm ?? params.SearchTerm,
    PageNumber: params.pageNumber ?? params.PageNumber,
    PageSize: params.pageSize ?? params.PageSize,
  };

  Object.entries(normalized).forEach(([key, value]) => {
    if (value == null || String(value).trim() === "") return;
    searchParams.append(key, String(value).trim());
  });

  return searchParams.toString();
}

export const CreateHolidayAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/Holiday`, data);
    dispatch({
      type: ADD_Holiday,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_Holiday,
      payload: "Error" + e,
    });
  }
};

export const GetAllHolidayAction = (query) => async (dispatch) => {
  try {
    const queryString =
      typeof query === "string"
        ? buildHolidayQuery(Object.fromEntries(new URLSearchParams(query)))
        : buildHolidayQuery(query);
    const url = queryString ? `/api/Holiday?${queryString}` : `/api/Holiday`;
    const respons = await GetDataToken(url);
    dispatch({
      type: GET_Holiday,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_Holiday,
      payload: "Error" + e,
    });
  }
};

export const UpdateHolidayAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Holiday`, body);
    dispatch({
      type: UPDATE_Holiday,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_Holiday,
      payload: "Error" + e,
    });
  }
};

export const DeleteHolidayAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Holiday?id=${Id}`);
    dispatch({
      type: DELETE_Holiday,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_Holiday,
      payload: "Error" + e,
    });
  }
};
